export default __webpack_public_path__ + "static/media/2gis.0ca6c36a.svg";